import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { OAuthService } from '../../../../../../../services/oauth.service';

@Component({
    selector: 'd365businesscentral-connector-panel',
    templateUrl: './d365businesscentral.connector.panel.html'
})
export class D365BusinessCentralConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Dynamics365 Business Central',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.D365BusinessCentralInfo',
            ControlType: D365BusinessCentralConnectorPanel,
            Default: null
        };
    }

    constructor(private service: OAuthService) {
        super();
    }

    authenticate() {
        if (this.DataSource && this.DataSource.SID) {
            this.service.GetOAuthURL(this.DataSource.SID, "CData").subscribe(x => {
                if (x) {
                    window.open(x, '_blank');
                }
            });
        }
    }
}
